import * as React from 'react';
import { connect } from 'react-redux';
import { setStep, handleStepBack, handleNextStep } from '../../../../actions/templateActions';
import KPDropdown from '../../SSPCustomComponentLibrary/KPDropdown/KPDropdown';
import './KPDropDownPage.css';
import { postToController } from '../../../../actions/apiActions';
import { setFnolIncidentEventList, setRiskItemAndIncident, setIncidentEvent } from '../../../../actions/claimSubmitActions';

class KPDropDownPage extends React.Component<any, any>  {
    constructor(props) {
        super(props);
        this.handleNext = this.handleNext.bind(this);
        this.handleNextStep = this.handleNextStep.bind(this);
        this.handleCoverSelection = this.handleCoverSelection.bind(this);
        this.handleIncidentSelection = this.handleIncidentSelection.bind(this);
        this.getIncidentTypes = this.getIncidentTypes.bind(this);
        this.getAllIncidentTypes = this.getAllIncidentTypes.bind(this);
        this.whichDropDownToDisplay = this.whichDropDownToDisplay.bind(this);

        this.state = {
            eventTypeList: "",
        };
    }

    async whichDropDownToDisplay(whichViewToDisplay) {
        await this.setState({ dropDownView: false, showStylingFoundationSteps: false });
        await this.setState({ dropDownView: whichViewToDisplay });
        if (whichViewToDisplay === "styling-steps") {
            await this.setState({ showStylingFoundationSteps: true });
        }
    }

    async handleNextStep(e: any) {
        await this.props.dispatchHandleNextStep();
    }

    async handleNext(e: any) {
        await this.props.dispatchHandleNextStep();
    }

    async handleIncidentSelection(e: any) {
        let eventType = this.state.eventTypeList.filter(function (item) {
            return item.id == e
        })
        this.props.dispatchSetIncidentEvent(eventType[0]);
        await this.setState({ nextDisabled: false });
        this.getIncidentTypesByIncidentEventTypeId(eventType[0]);
    }

    async getAllIncidentTypes(riskItemId) {
        await postToController(this.props.dispatch, 'GetAllEventTypes', JSON.stringify({ Parameter: riskItemId })).then(async (response) => {
            await this.setState({ eventTypeList: response });
            return true;
        })
    }

    handleCoverSelection = async (e: any) => {
        let coverItem = this.props.profile.personalPolicies[0].covers.filter(function (item) {
            return item.id == e;
        })

        this.getIncidentTypes(coverItem[0].id);
        this.setState({ selectedCover: coverItem[0], selectedEvent: null });

        await this.props.dispatchSetRiskItemAndIncident(coverItem[0], null);
    }

    async getIncidentTypes(riskItemId) {
        await postToController(this.props.dispatch, 'GetAllEventTypes', JSON.stringify({ Parameter: riskItemId })).then(async (response) => {
            await this.setState({ eventTypeList: response });
            return true;
        })
    }

    async getIncidentTypesByIncidentEventTypeId(incidentEventType) {
        await postToController(this.props.dispatch, 'GetIncidentTypesByIncidentEventTypeId', JSON.stringify({ EventTypeId: incidentEventType.id })).then(async (response) => {
            await this.setState({ incidentTypeList: response });
            await this.props.dispatchSetIncidentEventList(response, incidentEventType);
            return true;
        })
    }

    public render() {
        let covers = <div></div>;
        let eventTypes = <div></div>;
        if (this.state.eventTypeList) {
            eventTypes = this.state.eventTypeList.filter(item => item.description !== "Collision")
        }

        if (this.props.profile.personalPolicies[0] !== undefined) {
            covers = this.props.profile.personalPolicies[0].covers
                .filter((cover) => cover.isMainline === true && !cover.productName.startsWith("Bling") && !cover.productName.startsWith("Code red") && !cover.productName.startsWith("Warranty") && !cover.productName.startsWith("Personal") && cover.riskItems[0] !== undefined)
        }

        let simpleDropdownList = [
            { id: 1, description: 'Collision' },
            { id: 2, description: 'Fire' },
            { id: 3, description: 'Theft' },
            { id: 4, description: 'Storm' },
            { id: 5, description: 'Other' },
        ];

        let imageDropdownList = [
            { id: 1, image: 'car', headerText: 'Car', bodyText: '2020 BMW 220D M SPORT A/T(F22)' },
            { id: 2, image: 'car', headerText: 'Car', bodyText: '2018 MERCEDES-BENZ A 200D STYLE' },
        ];

        return (
            <>
            <div id="appContainer" className="noProfile styling-project">

                <div className="align-center text-center mt-60px">
                    <span className="styling-foundation-page-header">
                        Styling Foundation:
                        <br />
                        SSP Dropdown Component Lab
                    </span>
                    <br />
                    {/*/// Default ///*/}
                    {this.state.dropDownView == undefined &&
                        <>
                            <h5>Select a dropdown type to display from the top right menu</h5>
                        </>
                    }
                </div>

                {/*/// Show Styling Foundation Step Start ///*/}
                {this.state.showStylingFoundationSteps == true &&
                    <>
                        <div id="Style-header">
                            <div className="col-12 px-0 pb-lg-3">
                                <div className="p-2 text-lg-right invisible">
                                    <p className="Last-updated">Last updated: <span>-- -- -- --</span></p>
                                </div>
                                <div className="container-fluid">
                                    <div className="text-center">
                                        <h1>Styling Foundation</h1>
                                    </div>
                                    <div className="mt-5 text-center">
                                        <button className="claim-btn btn btn-solid-red w-25" onClick={this.handleNextStep}>Start</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                }

                {/*<KPDropdown data={simpleDropdownList} />
                    <KPDropdown data={imageDropdownList} />*/}
                <div className="row noma">
                    <div className="col nopa">
                        <fieldset>
                            <legend>
                                <b>Select the Dropdown to display</b>
                                <br />
                                Current: {this.state.dropDownView}
                            </legend>
                            <button onClick={() => this.whichDropDownToDisplay('fnol')}>FNOL / Claims Journey</button>
                            <br />
                            <button onClick={() => this.whichDropDownToDisplay('popup')}>Popup</button>
                            <br />
                            <button onClick={() => this.whichDropDownToDisplay('sales-journey')}>Sales Journey</button>
                            <br />
                            <hr />
                            <button onClick={() => this.whichDropDownToDisplay('styling-steps')}>Styling Steps</button>
                        </fieldset>
                    </div>
                </div>

                {/*/// FNOL / Claims Style ///*/}
                {this.state.dropDownView == "fnol" &&
                    <>
                        <div className="container fnol-claims-style">
                            <h5>FNOL / Claims Journey style</h5>
                            <div className="row">
                                <div className="col-12" title="SSP Image Dropdown">
                                    {/* Image dropdown */}
                                    <KPDropdown
                                        id={"newChooseItemFnol"}
                                        showLabelAfterSelection={true}
                                        showLabelInside={true}
                                        label={"Please select your vehicle"}
                                        labelAfterSelection={"Selected vehicle"}
                                        title={"Please select your vehicle"}
                                        isImageDropdown={true}
                                        data={covers}
                                        handleSelection={(e) => this.handleCoverSelection(e)} selectedValue={this.props.claimSubmit.selectedRiskItem}
                                    />
                                </div>
                                <div className="col-12" title="SSP List Dropdown">
                                    {/* List dropdown */}
                                    <KPDropdown
                                        id={"newIncidentTypeFnol"}
                                        label={"Please select the damage type"}
                                        showLabelAfterSelection={true}
                                        showLabelInside={true}
                                        labelAfterSelection={"Selected damage type"}
                                        title={"Please select the damage type"}
                                        data={eventTypes}
                                        handleSelection={(e) => this.handleIncidentSelection(e)} selectedValue={this.props.claimSubmit.incidentType}
                                    />
                                </div>
                            </div>

                        </div>
                    </>
                }

                {/*/// Popup Style ///*/}
                {this.state.dropDownView == "popup" &&
                    <>
                        <div className="container popup-style">
                            <h5>Popup style</h5>
                            <div className="row">
                                <div className="col-12" title="SSP Popup Dropdown">
                                    {/* Image dropdown */}
                                    <KPDropdown
                                        id={"popupChooseItemFnol"}
                                        className={"ssp-popup-dropdown"}
                                        showLabelAfterSelection={true}
                                        showLabelOutside={true}
                                        label={"Please select your vehicle"}
                                        labelAfterSelection={"Selected vehicle"}
                                        isImageDropdown={true}
                                        data={covers}
                                        handleSelection={(e) => this.handleCoverSelection(e)} selectedValue={this.props.claimSubmit.selectedRiskItem}
                                    />
                                </div>
                                <div className="col-12" title="SSP Popup Dropdown">
                                    {/* List dropdown */}
                                    <KPDropdown
                                        id={"popupIncidentTypeFnol"}
                                        className={"ssp-popup-dropdown"}
                                        label={"Please select the damage type"}
                                        showLabelAfterSelection={false}
                                        showLabelInside={true}
                                        showLabelOutside={true}
                                        labelAfterSelection={"Selected damage type"}
                                        data={eventTypes}
                                        handleSelection={(e) => this.handleIncidentSelection(e)} selectedValue={this.props.claimSubmit.incidentType}
                                    />
                                </div>
                            </div>

                        </div>
                    </>
                }

                {/*/// Sales Journey ///*/}
                {this.state.dropDownView == "sales-journey" &&
                    <>
                        <div className="container sales-journey-style">
                            <h5>Sales Journey style</h5>
                            <div className="row">
                                <div className="col-12" title="SSP Sales Journey Image Dropdown">
                                    {/* Image dropdown */}
                                    <KPDropdown
                                        id={"salesJourneyChooseItemFnol"}
                                        className={"ssp-sales-journey-dropdown"}
                                        isImageDropdown={true}
                                        showLabelAfterSelection={true}
                                        showLabelOutside={true}
                                        label={"Please select your vehicle"}
                                        labelAfterSelection={"Selected vehicle"}
                                        data={covers}
                                        handleSelection={(e) => this.handleCoverSelection(e)} selectedValue={this.props.claimSubmit.selectedRiskItem}
                                    />
                                </div>
                                <div className="col-12" title="SSP Sales Journey List Dropdown">
                                    {/* List dropdown */}
                                    <KPDropdown
                                        id={"salesJourneyIncidentTypeFnol"}
                                        className={"ssp-sales-journey-dropdown"}
                                        label={"Please select the damage type"}
                                        showLabelAfterSelection={true}
                                        showLabelOutside={true}
                                        labelAfterSelection={"Selected damage type"}
                                        data={eventTypes}
                                        handleSelection={(e) => this.handleIncidentSelection(e)} selectedValue={this.props.claimSubmit.incidentType}
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                }
            </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        props: state.loadingScreen,
        profile: state.profile,
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchSetTimeShow: () => dispatch(),
        dispatchSetStep: (step, subStep) => dispatch(setStep(step, subStep)),
        dispatchHandleStepBack: () => dispatch(handleStepBack()),
        dispatchHandleNextStep: () => dispatch(handleNextStep()),
        dispatchSetRiskItemAndIncident: (riskItem, incidentType) => dispatch(setRiskItemAndIncident(riskItem, incidentType)),
        dispatchSetIncidentEventList: (list, event) => dispatch(setFnolIncidentEventList(list, event)),
        dispatchSetIncidentEvent: (event) => dispatch(setIncidentEvent(event)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(KPDropDownPage)